/**
 * Classify the current client as one of "desktop" | "tablet" | "mobile".
 * Uses a UA scan first (catches iPad Pro reporting as desktop UA on Safari
 * via `maxTouchPoints`), then falls back to pointer-capability + viewport
 * width. Everything else is desktop.
 */
export function detectDeviceType() {
  try {
    const ua = (navigator.userAgent || "").toLowerCase();
    const touch = (navigator.maxTouchPoints || 0) > 1 ||
                  (window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
    const w = window.innerWidth || document.documentElement.clientWidth || 0;

    // iPadOS >= 13 masquerades as MacIntel — detect via touch + Mac UA
    const isIPad = /ipad/.test(ua) ||
                   (/macintosh/.test(ua) && (navigator.maxTouchPoints || 0) > 1);
    const isAndroidTablet = /android/.test(ua) && !/mobile/.test(ua);
    const isTabletUA = /tablet|kindle|playbook|silk/.test(ua) ||
                       isIPad || isAndroidTablet;

    const isMobileUA = /iphone|ipod|android.*mobile|windows phone|blackberry|opera mini/.test(ua);

    if (isTabletUA) return "tablet";
    if (isMobileUA) return "mobile";
    // Fallback: touch device sized like a tablet
    if (touch && w >= 768 && w <= 1366) return "tablet";
    if (touch && w < 768) return "mobile";
    return "desktop";
  } catch {
    return "desktop";
  }
}
